var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg18LogoWhiteOutlines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    fillRule: "nonzero",
    d: "M5 12H3.5V7h-.7V5.5L5 4.712V12zm5.857-5.273c0 .349-.086.657-.258.924-.172.267-.41.481-.711.643.341.168.612.398.812.69.2.291.3.636.3 1.035 0 .643-.22 1.15-.662 1.522-.441.373-1.049.559-1.823.559-.778 0-1.391-.187-1.84-.561-.45-.374-.675-.88-.675-1.52 0-.386.098-.727.295-1.023a2.01 2.01 0 01.837-.702 1.895 1.895 0 01-.719-.643 1.655 1.655 0 01-.26-.924c0-.626.211-1.12.634-1.483.424-.363.994-.544 1.713-.544.725 0 1.3.181 1.722.544.424.362.635.857.635 1.483zm-1.502 3.13c0-.305-.075-.538-.227-.702a.776.776 0 00-.598-.246.784.784 0 00-.6.246c-.154.164-.23.397-.23.701 0 .294.077.527.232.697.155.17.357.256.608.256a.752.752 0 00.59-.253c.15-.17.225-.402.225-.7zM8.48 5.911c-.222 0-.39.074-.506.221-.115.148-.173.352-.173.614 0 .258.059.467.176.626.117.16.29.239.517.239.225 0 .393-.08.506-.239.112-.159.168-.368.168-.626s-.058-.462-.173-.611c-.116-.15-.287-.224-.515-.224zM13 7h1v1h-1v1h-1V8h-1V7h1V6h1v1z"
  }))));
}

Svg18LogoWhiteOutlines.displayName = '18LogoWhiteOutlines';
export default Svg18LogoWhiteOutlines;